import script from "./ContextMenuBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextMenuBtn.vue?vue&type=script&setup=true&lang=js"

import "./ContextMenuBtn.vue?vue&type=style&index=0&id=71dd7a4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71dd7a4e"]])

export default __exports__